<template>
  <div class="page-box" ref="pageBox">
    <div class="back1 back" id="pageBox">
      <div class="back1-c">
        <div><h1>导师</h1></div>
        <div><h4>来自各行各业的高质量导师和行业专家</h4></div>
      </div><!--      底部三角-->
      <div class="Triangle">
        <div class="TriLeft"></div>
        <div class="TriRight"></div>
      </div>

    </div>
    <div class="main">
      <div class="con">

        <div class="conInfo" v-for="i in 15" :key="i">
          <div class="front">
            <p></p>
          </div>
          <div class="back">
            <div class="teacherInfo">
              <p>Ying</p>
              <p>sadsdas</p>
              <p>Aasdasdas</p>
              <button class="button">Learn More</button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!--    举办参加活动-->
    <div class="myActivity">
      <div class="box">
        <div class="boxInfo">
          <h1>参加/举办活动</h1>
          <h3>留下您的需求，我们会尽快予以回复</h3>
          <div class="form">
            <el-form :model="form" label-width="0" ref="form">
              <el-form-item class="comWidth" style="float: left">
                <el-input placeholder="姓名" v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item class="comWidth" style="float: right">
                <el-input placeholder="邮箱" v-model="form.address"></el-input>
              </el-form-item>
              <el-form-item style="width: 100%">
                <el-input :rows="8" placeholder="需求" type="textarea" v-model="form.msg"></el-input>
              </el-form-item>
              <el-form-item style="width: 100%">
                <el-button @click="submitForm('from')" style="color: #fff;background: none">确 定</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script lang="ts">
  import {defineComponent, reactive} from 'vue';
  import Footer from '@/components/footer.vue'

  export default defineComponent({
    name: "Teacher",
    components: {Footer},
    setup() {
      return reactive({
        form: {
          name: '',
          address: '',
          msg: ''
        }
      });
    },

    mounted() {
      this.$nextTick(() => {
        (this as any).pageBox = this.$refs['pageBox']
        console.log((this as any).pageBox);
        (this as any).pageBox.addEventListener('scroll', this.handleScroll, true);
      });
    },
    methods: {
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        console.log(scrollTop)
      },

      submitForm(formName: string) {
        (this as any).$refs[formName].validate((valid: any) => {
          if (valid) {
            console.log(this.form)
          }
        })
      }
    }

  })
</script>

<style lang="less" scoped>
  .main{
    width: 100%;height: auto;background:#fff;position: relative;z-index: 3;
  }
  .myActivity {
    width: 100%;
    height: 600px;
    background: #fff;
    position: relative;

    .box {
      background-repeat: no-repeat;
      /*background-size: 1298.45px 867.8px;*/
      background-color: transparent;
      background-position: -40.2269px 78.7781px;
      background-image: url('http://user-assets.sxlcdn.com/images/41713/FlGstAcriJaX_uNser7PaldzT1Ly.jpg?imageMogr2/strip/auto-orient/thumbnail/2000x1500%3E/quality/90!/interlace/1/format/jpg');
      background-size: 100% 100%;
      background-attachment: fixed;
      transition: padding-bottom .5s;
      width: 100%;
      height: 600px;

      .boxInfo {
        position: relative;
        width: 75%;
        margin: 0 auto;
        height: 450px;
        padding-top: 100px;
        color: #fff;
      }

      .form {
        padding-top: 50px;

        .comWidth {
          width: 49%;
        }
      }
    }

  }

  .back {
    position: relative;
    width: 100vw;
    box-sizing: border-box;
  }

  .back1 {
    min-height: calc(100vh - 180px);
  }

  .back1::before {
    content: "";
    position: absolute;
    top: -60px;
    left: 0;
    right: 0;
    bottom: 0;
    background: 50% 50% / cover;
    transform: translateZ(-1px) scale(2);
    background-image: url('http://user-assets.sxlcdn.com/images/41713/FjNIWHM-4l5jXzJ-DYhM8X4bTUtk.jpg?imageMogr2/strip/auto-orient/thumbnail/2000x1500>/quality/90!/interlace/1/format/jpeg');
  }

  .back1::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    display: block !important;
    background: rgba(0, 0, 0, .39);
  }

  .back1-c {
    position: absolute;
    width: 100%;
    min-width: 375px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    padding: 0 20px;
    box-sizing: border-box;
  }


  .back1-c {
    position: absolute;
    width: 100%;
    min-width: 375px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    padding: 0 20px;
    box-sizing: border-box;
    z-index: 2;
  }

  .back1-c h1 {
    font-size: 44px;
    font-weight: 400;
    margin-bottom: 15px;
  }

  .back1-c h4 {
    font-size: 22px;
    font-weight: 100;
  }

  .con {
    width: 100%;
    height: auto;
    padding: 50px 0;
    background: #fff;
    z-index: 2;
    position: relative;
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    max-width: 1000px;
    .conInfo:hover .front {
      transform: rotateY(180deg);
    }
    .conInfo:nth-child(even):hover .front {
      transform: rotateY(-180deg);
    }
    .conInfo:hover .back {
      transform: rotateY(0deg);
    }
    .conInfo:nth-child(even) .back {
      transform: rotateY(180deg);
    }
    .conInfo:nth-child(even):hover .back {
      transform: rotateY(0deg);
    }
    .conInfo {
      color: inherit;
      cursor: pointer;
      width: calc(20% - 2rem);
      min-width: calc(20% - 2rem);
      height: 240px;
      min-height: 240px;
      perspective: 1000px;
      margin: 1rem;
      position: relative;

      .front {
        width: 100%;height: 100%;
        font-size: 1.618rem;
        font-weight: 600;
        color: #fff;
        overflow: hidden;
        font-family: Poppins, sans-serif;
        background-image: url("http://user-assets.sxlcdn.com/images/41713/Fl3kwOlfBF8z9sx7lf9dsPEHVTc-.jpg?imageMogr2/strip/auto-orient/thumbnail/!200x200r/gravity/Center/crop/200x200/quality/90!/interlace/1/format/jpeg");
        background-size: cover;

      }

      .back {
        background: #fff;
        transform: rotateY(-180deg);
        padding: 0 2em;
        .teacherInfo{
          p{
            margin-bottom: 10px;
          }
        }
        .button {
          transform: translateZ(40px);
          cursor: pointer;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          color: #fff;
          padding: .5em 1em;
          border-radius: 100px;
          font: inherit;
          background: linear-gradient(135deg, #1a9be6, #1a57e6);
          border: none;
          position: relative;
          transform-style: preserve-3d;
          transition: 300ms ease;
        }
        .button:hover {
          transform: translateZ(55px);
        }
        .button:hover:before {
          transform: translateZ(-55px);
        }
        .button:active {
          transform: translateZ(20px);
        }
        .button:active:before {
          transform: translateZ(-20px);
          top: 12px;
        }
        .button:before {
          transition: 300ms ease;
          position: absolute;
          display: block;
          content: '';
          transform: translateZ(-40px);
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          height: calc(100% - 20px);
          width: calc(100% - 20px);
          border-radius: 100px;
          left: 10px;
          top: 16px;
          box-shadow: 0 0 10px 10px rgb(26,87,230 / 25%);
          background-color: rgba(26, 87, 230, 0.25);
        }
      }

      .front, .back {
        display: flex;
        border-radius: 6px;
        background-position: center;
        background-size: cover;
        text-align: center;
        justify-content: center;
        align-items: center;
        position: absolute;
        height: 100%;
        width: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        transform-style: preserve-3d;
        transition: ease-in-out 600ms;
      }


    }
  }
  @media screen and (max-width: 800px) {
    .conInfo {
      width: calc(50% - 2rem) !important;
    }
  }
  @media screen and (max-width: 500px) {
    .conInfo {
      width: 100% !important;
    }
  }
  @media screen and (max-width: 800px) {
    .back1-c h1 {
      font-size: 32px;
      margin-bottom: 8px;
    }

    .back1-c h4 {
      font-size: 14px;
    }

    .myActivity .box .boxInfo {
      padding-top: 60px;
    }

    .myActivity .box .boxInfo .form .comWidth {
      width: 100%;
    }

    .con {
      .conInfo {
        .left {
          width: 100%;

          img {
            display: block;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
          }
        }

        .right {
          width: calc(100% - 54px);
          border-top: 0;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        }
      }
    }
  }

  .s-bright-arrow {
    height: 25px;
    width: 100%;
    position: absolute;
    top: -25px;
    left: 0;
  }

  .a1,
  .a2 {
    position: absolute;
    bottom: 0;
    width: 50%;
    height: 0;
    z-index: 1;
    box-sizing: border-box;
    border: 25px solid transparent;
    border-top: none;
  }

  @media screen and (max-width: 800px) {
    .back1-c h1 {
      font-size: 32px;
      margin-bottom: 8px;
    }

    .back1-c h4 {
      font-size: 14px;
    }
  }
</style>
<i18n>
  {
  "en": {
  "hello": "Hello i18n in SFC!"
  },
  "zh":{
  "hello": "你好"
  }
  }
</i18n>